import { _PlayEntryBase } from './playEntryBase'

export class _PlayEntryDefault extends _PlayEntryBase {
  cssType: 'default' = 'default'
  protected initPC(): this {
    this['--play-entry-width'] = '0.6rem'
    this['--play-entry-height'] = '0.6rem'
    this['--play-icon-width'] = '0.3rem'
    this['--play-icon-height'] = '0.3rem'
    return this
  }
  protected initH5(): this {
    this['--play-entry-width'] = ''
    this['--play-entry-height'] = ''
    this['--play-icon-width'] = '0.5rem'
    this['--play-icon-height'] = '0.5rem'
    return this
  }
}
